module.exports = __webpack_public_path__ + "img/nature-75.9281fe6a.jpg";